import { BankAccount } from "./BankAccount";

export class CustomSellerInfo {
    id: string;
    customerId: string;
    brandInfoText: string;
    brandImage: Blob;
    bankAccount: BankAccount;
}